import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = ["disabled"];
import { reactive, ref, watch } from 'vue';
import { ElMessage } from 'element-plus';
import { createTextVersion } from '@/api/assets';
export default {
  __name: 'AssetTextVersionDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    asset: {
      type: Object,
      default: null
    }
  },
  emits: ['update:visible', 'success'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const form = reactive({
      textContent: '',
      changeRemark: ''
    });
    const submitting = ref(false);
    watch(() => props.visible, val => {
      if (val) {
        form.textContent = props.asset?.currentVersion?.textContent || '';
        form.changeRemark = '';
      }
    });
    function handleCancel() {
      emit('update:visible', false);
    }
    async function handleSubmit() {
      if (!props.asset?.id || !form.textContent) return;
      submitting.value = true;
      try {
        await createTextVersion(props.asset.id, {
          textContent: form.textContent,
          changeRemark: form.changeRemark || undefined
        });
        ElMessage.success('文本版本已创建');
        emit('success');
        emit('update:visible', false);
      } catch {
        // handled by interceptor
      } finally {
        submitting.value = false;
      }
    }
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createBlock(_component_el_dialog, {
        "model-value": __props.visible,
        title: "新增文本版本",
        width: "560px",
        "close-on-click-modal": false,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _ctx.$emit('update:visible', $event))
      }, {
        footer: _withCtx(() => [_createElementVNode("button", {
          type: "button",
          class: "btn-secondary",
          onClick: handleCancel
        }, "取消"), _createElementVNode("button", {
          type: "button",
          class: "btn-primary",
          disabled: !form.textContent || submitting.value,
          onClick: handleSubmit
        }, _toDisplayString(submitting.value ? '提交中...' : '保存版本'), 9, _hoisted_1)]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          model: form,
          "label-width": "80px",
          "label-position": "top"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "文本内容",
            required: ""
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.textContent,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.textContent = $event),
              type: "textarea",
              rows: 10,
              placeholder: "输入新版本文本内容（最大 200KB）",
              maxlength: "204800",
              "show-word-limit": ""
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "版本备注"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.changeRemark,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.changeRemark = $event),
              placeholder: "说明本次变更",
              maxlength: "500"
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"])]),
        _: 1
      }, 8, ["model-value"]);
    };
  }
};